module.exports = __webpack_public_path__ + "media/images/advisor/img_3_1-e6673066b76af945a5ac13f7ab69b755.png";